import {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../../selectors/pages/cashout/cashapp_new';
import {initializeCashapp, resetCashapp, createCashAppCashOutRequest} from '../../../../reducers/app/actions';
import {useNavigate} from 'react-router-dom';

import LoaderPage from '../../../components/loader_page';

import Enter from './enter';
import Request from './request';
import Alert from './alert';

export default () => {
    const {wallet, cashapp, createButton, confirmButton} = useSelector(Selector),
          dispatch = useDispatch(),
          navigate = useNavigate();

    const [stage, setStage] = useState('enter');

    useEffect(() => {
        if(!cashapp.initialized)
            dispatch(initializeCashapp(navigate));

        return () => dispatch(resetCashapp());
    }, [navigate]);

    if(!cashapp.initialized)
        return <LoaderPage />;

    if(!cashapp.request)
        return <Enter onNext={data => {
                // console.log(data);
                dispatch(createCashAppCashOutRequest(data, navigate));
                // setStage('request');
        }} wallet={wallet} button={createButton} />

    if(cashapp.request && !cashapp.request.confirmed)
        return <Request request={cashapp.request} button={confirmButton} />

    return <Alert request={cashapp.request} />
}